module.exports = __webpack_public_path__ + "img/thanks_ja.e4e12ee1.png";